itsoftApp.createModule("dashAnimation", function () {
    var module = this; 
    var viewWidthEl = document.querySelector(".js-viewport");
    var viewport = itsoftApp.utils.getViewportSize();

    var initAnimation = function (el) {
        var defaultPath = el.querySelector(".page__dashed-path");
        var maskedPath = el.querySelector(".page__masked-path");

        if (maskedPath) {
            var pathLength = maskedPath.getTotalLength();
            maskedPath.style.strokeDasharray = pathLength;
            maskedPath.style.strokeDashoffset = pathLength;

            defaultPath.style.opacity = "1";
            maskedPath.style.opacity = "1";

            if (viewWidthEl) {
                if (viewport > 1440 && defaultPath.hasAttribute("vector-effect")) {
                    defaultPath.removeAttribute("vector-effect");
                    maskedPath.removeAttribute("vector-effect");
                }
            }

            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    maskedPath.style.transition = "stroke-dashoffset 1s ease-in";
                    maskedPath.style.strokeDashoffset = 0;
                });
            });
        } else if (defaultPath) {
            var pathLength = defaultPath.getTotalLength();
            defaultPath.style.opacity = "1";
            defaultPath.style.strokeDasharray = pathLength;
            defaultPath.style.strokeDashoffset = pathLength;
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    defaultPath.style.transition = "stroke-dashoffset 1s ease-in";
                    defaultPath.style.strokeDashoffset = 0;
                });
            });
        }
    }

    var initCustomAnimation = function (defaultPath) {
        var pathLength = defaultPath.getTotalLength();
        defaultPath.style.opacity = "1";
        defaultPath.style.strokeDasharray = pathLength;
        defaultPath.style.strokeDashoffset = pathLength;

        return {
            pathLength: pathLength,
            updateParams: function (value) {
                defaultPath.style.strokeDashoffset = value;
            }
        }
    }

    module.initAnimation = initAnimation;
    module.initCustomAnimation = initCustomAnimation;
});